// extracted by mini-css-extract-plugin
export default {"productGrid":"n1-z","centerLink":"o1-z","productSection":"p1-z","item":"q1-z","ctaButton":"r1-z"};